export default (to, from, next) => {

        if (obj_user.usuarioLogado()) {

                var user = JSON.parse(obj_user.getUser());
                //console.log("user?"); console.log( user );

                if (user.perfil_id.toString() == "1") {
                }

                if (user.perfil.toString().toLowerCase() == "cliente") {

                        next('/area'); //mando para a área de cliente. Outros perfis tenho que tratar aqui..
                } else {

                        next('/operacional/dashboard');  //Deixei no padrão a área do administrador..
                }
                // 
        } else {

                next('/login');
        }

}